<template>
  <Layout :title="$t('smartTags.smartTagsTitle')">
    <div :class="prefixCls">
      <div :class="prefixCls + '__body'">
        <HaiUpload @onChange="onClickSubmit" :maxSize="20"></HaiUpload>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import HaiUpload from '@/components/HaiUpload'
import { GetSmartTags, GetSmartTagsResult } from '../api/create'

const prefixCls = 'smart-tag-page'
export default {
  name: 'SmartTags',
  components: {
    Layout,
    HaiUpload
  },

  data() {
    return {
      prefixCls,
      currentRes: 0
    }
  },

  methods: {
    async onClickSubmit(file) {
      const formData = new FormData()
      formData.append('file', file)
      this.currentRes = await this.$Loading.startTo(0, 0, this.$t('wait'))
      try {
        const response = await GetSmartTags(formData)
        if (response.code === 200) {
          await this.getFetchResult(response.task_id)
        } else {
          this.toNextPage()
        }
      } catch (e) {
        this.toNextPage()
      }
    },

    async getFetchResult(task_id) {
      const response = await GetSmartTagsResult({ task_id })
      if (response.code === 200 && response.data.schedule < 100) {
        if (this.currentRes === +response.data.schedule) {
          setTimeout(() => {
            this.getFetchResult(task_id)
          }, 2000)
        } else {
          if (+response.data.schedule > this.currentRes) {
            await this.$Loading.startTo(
              this.currentRes,
              +response.data.schedule,
              response.data.message[this.$i18n.locale]
            )
            this.currentRes = +response.data.schedule
            await this.getFetchResult(task_id)
          } else {
            setTimeout(() => {
              this.getFetchResult(task_id)
            }, 2000)
          }
        }
      } else {
        this.toNextPage(response.data)
      }
    },

    toNextPage(data) {
      window.sessionStorage.setItem('smart_tag_data', JSON.stringify(data))
      this.$router.push({ name: 'smartTagsResult' })
      this.$Loading.finish()
    }
  }
}
</script>

<style lang="scss">
$prefixCls: 'smart-tag-page';
.#{$prefixCls} {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  &__body {
    width: 440px;
    padding: 0 20px;
    margin-top: 180px;
  }
}
</style>
